// extracted by mini-css-extract-plugin
export default {"submit":"buy-checkout-form-submit-module__submit"};